/**
 * @desc 查询水泥生产季度计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterCementProductResponse>> {
  return defHttp.post({
    url: '/web/plan/quarter/queryPlanCementProduct',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterCementProductResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/queryPlanCementProduct',
    data,
  });
}
